import React from 'react'
import { Box, Typography, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

const useStyles = makeStyles((theme) => ({
  errorPaper: {
    backgroundColor: '#FEF2F2',
    border: '1px solid #FCA5A5',
    borderLeft: '4px solid #DC2626',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  errorIcon: {
    color: '#DC2626',
    fontSize: 20,
    marginTop: theme.spacing(0.25),
  },
  errorBadge: {
    backgroundColor: '#DC2626',
    color: 'white',
    padding: '4px 8px',
    borderRadius: 4,
    fontWeight: 600,
    fontSize: '0.75rem',
  },
  lineBadge: {
    backgroundColor: 'white',
    border: '1px solid #E5E7EB',
    padding: '4px 8px',
    borderRadius: 4,
    fontFamily: 'monospace',
    fontSize: '0.75rem',
  },
  errorMessage: {
    color: '#991B1B',
    textTransform: 'capitalize',
    fontSize: '0.875rem',
  },
}))

function RenderCompilation({ error }) {
  const classes = useStyles()

  const parseError = (line) => {
    // Extract: filename:line:column: message
    const match = line.match(/([^/]+\.\w+):(\d+):\d+:\s*(.+)$/)

    if (match) {
      return {
        file: match[1],
        line: match[2],
        message: match[3].trim(),
      }
    }

    // Fallback: clean up the line
    return {
      file: null,
      line: null,
      message: line.replace(/^#\s*/, '').split(':').pop().trim(),
    }
  }

  const errors = error.outputLines.map(parseError)

  return (
    <Paper elevation={0} className={classes.errorPaper}>
      {errors.map((err, idx) => (
        <Box
          key={idx}
          display="flex"
          alignItems="flex-start"
          style={{ gap: 12 }}
        >
          <ErrorOutlineIcon className={classes.errorIcon} />

          <Box flex={1}>
            <Box
              display="flex"
              alignItems="center"
              flexWrap="wrap"
              mb={0.5}
              style={{ gap: 8 }}
            >
              <Typography component="span" className={classes.errorBadge}>
                COMPILATION ERROR
              </Typography>

              {err.line && (
                <Typography component="span" className={classes.lineBadge}>
                  Line {err.line}
                </Typography>
              )}
            </Box>

            <Typography className={classes.errorMessage}>
              {err.message}
            </Typography>
          </Box>
        </Box>
      ))}
    </Paper>
  )
}

export default RenderCompilation
